import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Checkbox from './Checkbox'
import Panel from './Panel'
import QuestionText from './QuestionText'

import { checkQuestion } from '../../actioncreators/actioncreators'

const Questions = () => {
  const dispatch = useDispatch()
  const questions = useSelector(state => state.questions)

  return (
    <div style={{ display: 'flex', flexFlow: 'row wrap', backgroundColor: '#f4f5f7', paddingLeft: '1.5%', paddingTop: '1.5%' }}>
      {questions.map(question =>
        <Panel key={question.id}>
          <div style={{ display: 'flex' }}>
            <QuestionText>
              {question.text || String.fromCharCode(160)}
            </QuestionText>
            <Checkbox onChange={() => dispatch(checkQuestion(question.id))} checked={question.checked} />
          </div>
        </Panel>
      )}
    </div>
  )
}

export default Questions